import React, { useState } from "react";
import { Input, Label, Table } from "reactstrap";
import { latestSalesTableData } from "../../../../Data/Dashboard/EcommerceDashboard/EcommerceDashboard";
import { SearchTableButton } from "../../../../utils/Constant";

const LatestSalesTable = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems = latestSalesTableData.filter((item) => item.customer.name && item.customer.name.toLowerCase().includes(filterText.toLowerCase()));

  return (
    <div className='table-responsive dataTables_wrapper custom-scrollbar'>
      <div className='dataTables_filter'>
        <Label>{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type='search' value={filterText} />
      </div>
      <Table className='display' id='latest-sales' responsive>
        <thead>
          <tr>
            <th className="checkbox-checked">
              <Input type='checkbox' />
            </th>
            <th>Customer</th>
            <th>Product</th>
            <th>Address</th>
            <th>Total</th>
            <th>Payment</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredItems.length > 0 ? (
            <>
              {filteredItems.map((sale, index) => (
                <tr key={index}>
                  <td className="checkbox-checked">
                    <Input type='checkbox' />
                  </td>
                  <td>
                    <div className='d-flex gap-2'>
                      <div className='flex-shrink-0'>
                        <img src={sale.customer.image} alt='user' />
                      </div>
                      <div className='flex-grow-1'>
                        <a href='letter-box.html'>
                          <h6 className='f-w-600'>{sale.customer.name}</h6>
                          <span>{sale.customer.email}</span>
                        </a>
                      </div>
                      <div className='active-status active-online'></div>
                    </div>
                  </td>
                  <td>
                    <h6 className='f-w-600'>{sale.product}</h6>
                    <span>{sale.productId}</span>
                  </td>
                  <td>{sale.address}</td>
                  <td>{sale.total}</td>
                  <td>{sale.payment}</td>
                  <td>
                    <div className='order'>
                      <span>{sale.status}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </>
          ) : (
            <>
              <tr className='text-center'>
                <td colSpan={7}>
                  <h6>No matching records found</h6>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default LatestSalesTable;
